const baseurl = "https://api-dev.fusionkitchen.co.uk";
const keyurl = " https://ire-fmb-api-new.fusionkitchen.co.uk/paymentCustom";
const keyurl2 = "https://fmbonedb-config.fusiontesting.co.uk/getClientApiKey";
const local  = "http://localhost:8080";
const liveurl = "https://api.fmb.eposapi.co.uk";


//Live
export const POSTPAYMENTINTENT = keyurl;
export const GETCLIENTKEY = keyurl2;
export const INSERTPAYMENTAMOUNT = keyurl;
//dev
// export const POSTPAYMENTINTENT = keyurl;
// export const GETCLIENTKEY = keyurl;
// export const INSERTPAYMENTAMOUNT = keyurl;
//Local
// export const POSTPAYMENTINTENT = keyurl;
// export const GETCLIENTKEY = keyurl;
// export const INSERTPAYMENTAMOUNT = keyurl;